__turbopack_context__.v({
  "black": "ButtonOrLink-module-scss-module__-xubOG__black",
  "bounce": "ButtonOrLink-module-scss-module__-xubOG__bounce",
  "button": "ButtonOrLink-module-scss-module__-xubOG__button",
  "content": "ButtonOrLink-module-scss-module__-xubOG__content",
  "dark": "ButtonOrLink-module-scss-module__-xubOG__dark",
  "fade-in": "ButtonOrLink-module-scss-module__-xubOG__fade-in",
  "green": "ButtonOrLink-module-scss-module__-xubOG__green",
  "iconLeft": "ButtonOrLink-module-scss-module__-xubOG__iconLeft",
  "iconRight": "ButtonOrLink-module-scss-module__-xubOG__iconRight",
  "iconWrapper": "ButtonOrLink-module-scss-module__-xubOG__iconWrapper",
  "menuLink": "ButtonOrLink-module-scss-module__-xubOG__menuLink",
  "nextQuestion": "ButtonOrLink-module-scss-module__-xubOG__nextQuestion",
  "onlyIcon": "ButtonOrLink-module-scss-module__-xubOG__onlyIcon",
  "primary": "ButtonOrLink-module-scss-module__-xubOG__primary",
  "pulse": "ButtonOrLink-module-scss-module__-xubOG__pulse",
  "red": "ButtonOrLink-module-scss-module__-xubOG__red",
  "secondary": "ButtonOrLink-module-scss-module__-xubOG__secondary",
  "secondaryMain": "ButtonOrLink-module-scss-module__-xubOG__secondaryMain",
  "slide-in": "ButtonOrLink-module-scss-module__-xubOG__slide-in",
  "slide-left": "ButtonOrLink-module-scss-module__-xubOG__slide-left",
  "slide-right": "ButtonOrLink-module-scss-module__-xubOG__slide-right",
  "socials": "ButtonOrLink-module-scss-module__-xubOG__socials",
  "text": "ButtonOrLink-module-scss-module__-xubOG__text",
  "white": "ButtonOrLink-module-scss-module__-xubOG__white",
});
